import ProviderFoodCard from "../providerDetails/ProviderFoodCard";

import "./PopularFoods.css";

export default function PopularFoods({
  foods = [],
}) {

  if (!foods.length) return null;

  return (

    <section className="popular-foods">

      <div className="popular-foods-header">

        <div>

          <h2>🔥 Popular Foods</h2>

          <p>
            Discover delicious dishes from
            nearby HomeFoods partners
          </p>

        </div>

        <button className="view-all-btn">
          View All
        </button>

      </div>

      <div className="popular-foods-grid">

        {foods.map((food) => (

          <ProviderFoodCard
            key={food.id}
            food={food}
          />

        ))}

      </div>

    </section>

  );

}